import React from "react";
import { Link } from "react-router-dom";
import { FinalLogo } from "../../lib/assets";
import { HashLink } from "react-router-hash-link";
import { FaWhatsapp } from 'react-icons/fa';
const isMobile = window.innerWidth < 768;


export const FooterTwo = () => {
  return (
    <footer>
      <div className="footer-area-two footer-bg-two">
        <div className="footer-top-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <div className="fw-logo">
                    <Link to="/">
                     <img src={FinalLogo} alt="" style={{zoom: isMobile ? "120%" : "200%", paddingLeft:"22px"}}  />
                    </Link>
                    
                  </div>

                  <div className="footer-content">
                    <span>
                      <h3>
                        Trio Management Consultants
                        <p className="text-muted text-end fs-6 me-3 text-success" style={{fontFamily: 'Comic Sans MS'}}>Team works</p>
                      </h3>
                    </span>
                    <div className="footer-info">
                      <ul className="list-wrap">
                        <li>
                          <div className="icon">
                            <i className="flaticon-phone-call"></i>
                          </div>
                          <div className="content">
                            <a href="tel:+91 9841012134">+91 - 98410 12134 / +91 - 98416 71160</a>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                          <FaWhatsapp style={{ fontSize: '20px', color: '#0759FF' }} />
                          </div>
                          <div className="content">
                            <a href="https://wa.me/919841671160?text=Hi">+91 9841671160</a>
                          </div>
                        </li>
                        <li>
                          <div className="icon">
                            <i className="flaticon-location"></i>
                          </div>
                          <div className="content">
                            <p>
                            No: 2, Elango Street, <br /> Ambedkar Nagar, Pattabiram, <br/> Chennai – 600072, Tamil Nadu, India
                            </p>
                          </div>
                        </li>
                        
                      </ul>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Menu</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/about-4">Company</Link>
                      </li>
                    
                      <li>
                        <Link to="/blog">Our Blog</Link>
                      </li>
                      <li>

                        <Link to="/privacypolicy">Privacy Policy</Link>
                      </li>
                      <li>
                        <Link to="/qualitypolicy">Quality Policy</Link>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-2 col-md-5 col-sm-6">
                <div className="footer-widget">
                  <h4 className="fw-title">Quick Links</h4>
                  <div className="footer-link">
                    <ul className="list-wrap">
                      <li>
                        <Link to="/services">How it’s Work</Link>
                      </li>
                     
                      <li>
                        <HashLink to="/#Testimonial">Testimonials</HashLink>
                      </li>
                      <li>
                        <HashLink to="/#ProjectArea">Projects</HashLink>
                      </li>
                      <li>
                      <Link to="/standards">ISO Standards</Link>
                      </li>
                     
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-7">
                <div className="footer-widget">
                  <h4 className="fw-title">Our Newsletter</h4>
                  <div className="footer-newsletter">
                    <p>
                      Sign up to Our weekly newsletter to get the latest
                      updates.
                    </p>
                    <form action="#">
                      <input type="email" placeholder="enter your e-mail" />
                      <button type="submit">Subscribe</button>
                    </form>
                    <div className="footer-social footer-social-two">
                      <ul className="list-wrap">
                      <li>
                          < a href ="https://wa.me/919841671160?text=Hi">
                          <i className="fab fa-whatsapp fa-1.75x"></i> 
                          </a>
                        </li>
                      <li>
                          <a href="https://x.com/Management51983">
                            <i className="fa fa-twitter"></i>
                          </a>
                        </li>
                        {/*
                        <li>
                          <a href="#">
                            <i className="fab fa-facebook-f"></i>
                          </a>
                        </li>
                        
                        <li>
                          <a href="#">
                            <i className="fab fa-instagram"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                          <i className="fab fa-linkedin"></i>
                          </a>
                        </li>
                        <li>
                          <a href="#">
                            <i className="fab fa-youtube"></i>
                          </a>
                        </li>*/}
                      </ul> 
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom-two">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="copyright-text-two text-center">
                  <p>Copyright © Ratoon Infotech | All Right Reserved</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};
